import { render, staticRenderFns } from "./HsSettings.vue?vue&type=template&id=0737e7ff&scoped=true"
import script from "./HsSettings.vue?vue&type=script&lang=js"
export * from "./HsSettings.vue?vue&type=script&lang=js"
import style0 from "./HsSettings.vue?vue&type=style&index=0&id=0737e7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737e7ff",
  null
  
)

export default component.exports